export class Location {
  constructor(row, column) {
    this.row = row
    this.column = column
  }
}

export class Range {
  constructor(start, end) {
    if (start.row > end.row) {
      ;[start.row, end.row] = [end.row, start.row]
    }

    if (start.column > end.column) {
      [start.column, end.column] = [end.column, start.column]
    }

    this.start = start
    this.end = end

    this.width = end.column - start.column
    this.height = end.row - start.row

    this._cellList = []
    for (let i = start.row; i <= end.row; i++) {
      let row = []
      for (let j = start.column; j <= end.column; j++) {
        let tmpLocation = new Location(i, j)
        row.push(tmpLocation)
      }
      this._cellList.push(row)
    }
  }

  get cellList() {
    if (!this._cellList) {
      return []
    }
    return this._cellList
  }
}
